import { useMemo } from "react";

type Props = {
  currentQuestion: any;
};

const RepeatedField = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  const repeatedConfig = properties?.repeatedConfig.columns;

  const rowAggregate = properties?.repeatedConfig.rowAggregate;
  const columnAggregate = useMemo(() => {
    return repeatedConfig.some((col: any) => !!col.aggregateType);
  }, [repeatedConfig]);

  const array = new Array(10).fill(0);
  return (
    <>
      <table>
        <thead>
          <tr>
            <td></td>
            {repeatedConfig?.map((col: any, i: number) => (
              <td key={i}>{col.label}</td>
            ))}
            {rowAggregate && (
              <td style={{ textAlign: "center", textTransform: "capitalize" }}>
                {rowAggregate}
              </td>
            )}
          </tr>
        </thead>
        <tbody>
          {array.map((id, i) => (
            <tr key={i}>
              <td style={{ width: "100px" }}>{i + 1}</td>
              {repeatedConfig?.map((_: any, j: number) => (
                <td key={j}>
                  <input style={{ width: "100px", height: "35px" }} />
                </td>
              ))}
              {rowAggregate && (
                <td style={{ textAlign: "center" }}>{rowAggregate}</td>
              )}
            </tr>
          ))}
          {columnAggregate && (
            <tr key={"col-aggregate"}>
              <td style={{ textAlign: "center" }}>Aggregate</td>
              {repeatedConfig?.map((col: any, j: number) => (
                <td style={{ textAlign: "center" }} key={j}>
                  {col.aggregateType ? col.aggregateType : "-"}
                </td>
              ))}
              {rowAggregate && <td></td>}
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default RepeatedField;
